// @flow

import * as React from 'react';
import moment from 'moment';
import styled from '@emotion/styled';

type Props = {
  player: Object
};

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  color: theme.color.basis2,
  display: 'flex',
  flexDirection: 'column',
  fontSize: theme.fontSize.small,
  width: '100%',
  overflowY: 'scroll',
  padding: theme.spacing.default
}));

const Article = styled.div(({ theme }) => ({
  marginBottom: theme.spacing.small
}));

const PostDate = styled.p(({ theme }) => ({
  color: theme.color.green,
  fontSize: theme.fontSize.default
}));

const NoNews = styled.div(({ theme }) => ({
  textAlign: 'center',
  width: '100%',
  padding: theme.spacing.default,
  fontSize: theme.fontSize.small
}));

function News({ player }: Props) {
  if (!player.news) {
    return <NoNews>No news is good news!</NoNews>;
  }

  return (
    <Wrapper>
      {player.news.map((item, i) => (
        <Article
          key={`news_${i}`} // eslint-disable-line
        >
          {item.date && <PostDate>{moment(item.date).format('DD MMM YYYY')}</PostDate>}
          {item.notes && <p>Update: {item.notes}</p>}
          {item.analysis && <p>Analysis: {item.analysis}</p>}
        </Article>
      ))}
    </Wrapper>
  );
}

export default News;
